import { typeOf } from 'xgplayer/src/utils/util'

let s_i18n = function () {
  let player = this
  let lang = {}
  lang.en = {
    HAVE_NOTHING: 'There is no information on whether audio/video is ready',
    HAVE_METADATA: 'Audio/video metadata is ready ',
    HAVE_CURRENT_DATA: 'Data about the current play location is available, but there is not enough data to play the next frame/millisecond',
    HAVE_FUTURE_DATA: 'Current and at least one frame of data is available',
    HAVE_ENOUGH_DATA: 'The available data is sufficient to start playing',
    NETWORK_EMPTY: 'Audio/video has not been initialized',
    NETWORK_IDLE: 'Audio/video is active and has been selected for resources, but no network is used',
    NETWORK_LOADING: 'The browser is downloading the data',
    NETWORK_NO_SOURCE: 'No audio/video source was found',
    MEDIA_ERR_ABORTED: 'The fetch process is aborted by the user',
    MEDIA_ERR_NETWORK: 'An error occurred while downloading',
    MEDIA_ERR_DECODE: 'An error occurred while decoding',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Audio/video is not supported',
    REPLAY: 'Replay',
    ERROR: 'Network is offline',
    PLAY_TIPS: 'Play',
    PAUSE_TIPS: 'Pause',
    PLAYNEXT_TIPS: 'Play next',
    DOWNLOAD_TIPS: 'Download',
    ROTATE_TIPS: 'Rotate',
    RELOAD_TIPS: 'Reload',
    FULLSCREEN_TIPS: 'Fullscreen',
    EXITFULLSCREEN_TIPS: 'Exit fullscreen',
    CSSFULLSCREEN_TIPS: 'Cssfullscreen',
    EXITCSSFULLSCREEN_TIPS: 'Exit cssfullscreen',
    TEXTTRACK: 'Caption',
    PIP: 'Pip',
    MINIPLAYER: 'Miniplayer',
    SCREENSHOT: 'Screenshot',
    LIVE: 'LIVE',
    OFF: 'Off',
    MINIPLAYER_DRAG: 'Click and hold to drag',
    AIRPLAY_TIPS: 'Airplay'
  }
  lang.es = {
    HAVE_NOTHING: 'No hay información sobre si el audio/vídeo está listo',
    HAVE_METADATA: 'Los metadatos de audio/vídeo están listos',
    HAVE_CURRENT_DATA: 'Hay datos disponibles sobre la posición de reproducción actual, pero no hay suficientes datos para reproducir el siguiente fotograma/milisegundo',
    HAVE_FUTURE_DATA: 'Hay datos disponibles para el siguiente fotograma como mínimo',
    HAVE_ENOUGH_DATA: 'Hay suficientes datos disponibles para iniciar la reproducción',
    NETWORK_EMPTY: 'El audio/vídeo aún no se ha inicializado',
    NETWORK_IDLE: 'El audio/vídeo está activo y ya se ha seleccionado un recurso pero no se está utilizando la red',
    NETWORK_LOADING: 'El navegador está descargando datos',
    NETWORK_NO_SOURCE: 'No se ha encontrado la fuente de audio/vídeo',
    MEDIA_ERR_ABORTED: 'El proceso de recuperación ha sido abortado por el usuario',
    MEDIA_ERR_NETWORK: 'Ha ocurrido un error al descargar',
    MEDIA_ERR_DECODE: 'Ha habido un problema al resolver la reproducción: el archivo no puede reproducirse',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Formato de audio/vídeo no soportado',
    REPLAY: 'Volver a reproducir',
    ERROR: 'Parece que hay un problema con la conexión de red',
    PLAY_TIPS: 'Emitir',
    PAUSE_TIPS: 'Pausar',
    PLAYNEXT_TIPS: 'Siguiente episodio',
    DOWNLOAD_TIPS: 'Descargar',
    ROTATE_TIPS: 'Rotar',
    RELOAD_TIPS: 'Volver a cargar',
    FULLSCREEN_TIPS: '进入全屏',
    EXITFULLSCREEN_TIPS: 'Salir de la pantalla completa',
    CSSFULLSCREEN_TIPS: 'Entrar en el modo de pantalla completa',
    EXITCSSFULLSCREEN_TIPS: 'Salir del modo de pantalla completa',
    TEXTTRACK: 'Subtítulos',
    PIP: 'Imagen superpuesta',
    MINIPLAYER: 'Minirreproductor',
    SCREENSHOT: 'Captura de pantalla',
    LIVE: 'Retransmitiendo en vivo',
    OFF: 'Cerrar',
    MINIPLAYER_DRAG: 'Mantenga pulsado para arrastrar el vídeo',
    AIRPLAY_TIPS: 'AirPlay',
    onlyPlayTip: 'Solo se reproducirán {msg} minutos, inicie sesión para verlo entero',
    loginTextButton: 'Iniciar sesión',
    replayButton: 'Volver a reproducir',
    nextButton: 'Siguiente episodio',
    refreshButton: 'Refrescar',
    episode: 'Episodio'
  }
  lang.fr = {
    HAVE_NOTHING: " Il n'y a pas d'information sur la disponibilité de l'audio/vidéo ",
    HAVE_METADATA: ' Les métadonnées audio/vidéo sont prêtes ',
    HAVE_CURRENT_DATA: " Les données relatives à la position de lecture actuelle sont disponibles, mais il n'y a pas assez de données pour lire l'image suivante ",
    HAVE_FUTURE_DATA: " Les données de l'image actuelle et au moins de l'image suivante sont disponibles ",
    HAVE_ENOUGH_DATA: ' Les données disponibles sont suffisantes pour commencer la lecture ',
    NETWORK_EMPTY: " L'audio/vidéo n'a pas été initialisé ",
    NETWORK_IDLE: " La ressource audio/vidéo est active et sélectionnée, mais le réseau n'est pas utilisé ",
    NETWORK_LOADING: ' Le navigateur est en train de télécharger des données ',
    NETWORK_NO_SOURCE: " Aucune source audio/vidéo n'est trouvée ",
    MEDIA_ERR_ABORTED: " Le processus de récupération est interrompu par l'utilisateur ",
    MEDIA_ERR_NETWORK: ' Une erreur se produit pendant le téléchargement ',
    MEDIA_ERR_DECODE: " Une erreur se produit pendant l'analyse de la lecture:  Aucun fichier ne peut être lu ",
    MEDIA_ERR_SRC_NOT_SUPPORTED: " Le format audio/vidéo n'est pas pris en charge ",
    REPLAY: ' Relecture ',
    ERROR: ' Une erreur se produit dans la connexion réseau ',
    PLAY_TIPS: ' Relecture ',
    PAUSE_TIPS: ' Pause ',
    PLAYNEXT_TIPS: ' Épisode suivant ',
    DOWNLOAD_TIPS: ' Télécharger ',
    ROTATE_TIPS: ' Tourner ',
    RELOAD_TIPS: ' Recharger ',
    FULLSCREEN_TIPS: ' Vers le plein écran ',
    EXITFULLSCREEN_TIPS: ' Quitter le plein écran ',
    CSSFULLSCREEN_TIPS: ' Vers le plein écran pour le style ',
    EXITCSSFULLSCREEN_TIPS: ' Quitter le plein écran pour le style ',
    TEXTTRACK: ' Sous-titres ',
    PIP: " Incrustation d'image",
    MINIPLAYER: ' Mini lecteur ',
    SCREENSHOT: " Capture d'écran ",
    LIVE: ' Diffusion directe',
    OFF: ' Désactiver ',
    MINIPLAYER_DRAG: ' Cliquez et maintenez pour faire glisser la vidéo ',
    AIRPLAY_TIPS: ' Airplay ',
    onlyPlayTip: ' Ne jouer que les {msg} minutes, et se connecter pour voir le film complet ',
    loginTextButton: ' Se connecter ',
    replayButton: ' Relecture',
    nextButton: ' Prochain épisode ',
    refreshButton: ' Rafraîchir ',
    episode: ' Épisode '
  }
  lang['in_ID'] = {
    HAVE_NOTHING: 'Tidak ada info tentang ketersediaan audio/video',
    HAVE_METADATA: 'Metadata audio/video sudah tersedia',
    HAVE_CURRENT_DATA: 'Data untuk lokasi pemutaran saat ini bisa digunakan, tetapi tidak ada data yang cukup untuk memutar frame/milidetik berikutnya',
    HAVE_FUTURE_DATA: 'Data saat ini atau setidaknya frame berikutnya bisa digunakan',
    HAVE_ENOUGH_DATA: 'Data yang bisa digunakan cukup untuk memulai pemutaran',
    NETWORK_EMPTY: 'Audio/video belum diiniliasisasi',
    NETWORK_IDLE: 'Audio/video aktif dan sumber daya juga sudah dipilih, tetapi internet belum diaktifkan',
    NETWORK_LOADING: 'Peramban sedang mengunduh data',
    NETWORK_NO_SOURCE: 'Sumber audio/video belum ditemukan',
    MEDIA_ERR_ABORTED: 'Proses pengambilan kembali dihentikan oleh pengguna',
    MEDIA_ERR_NETWORK: 'Terjadi kesalahan saat mengunduh',
    MEDIA_ERR_DECODE: 'Analisis pemutaran gagal: tidak bisa memutar file',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Format audio/video tidak didukung',
    REPLAY: 'Putar ulang',
    ERROR: 'Sepertinya ada masalah koneksi jaringan',
    PLAY_TIPS: 'Putar',
    PAUSE_TIPS: 'Jeda',
    PLAYNEXT_TIPS: 'Episode berikutnya',
    DOWNLOAD_TIPS: 'Unduh',
    ROTATE_TIPS: 'Putar',
    RELOAD_TIPS: 'Muat ulang',
    FULLSCREEN_TIPS: 'Buka layar penuh',
    EXITFULLSCREEN_TIPS: 'Tutup layar penuh',
    CSSFULLSCREEN_TIPS: 'Buka layar penuh',
    EXITCSSFULLSCREEN_TIPS: 'Tutup layar penuh',
    TEXTTRACK: 'Subtitle',
    PIP: 'Gambar dalam gambar',
    MINIPLAYER: 'Pemutar mini',
    SCREENSHOT: 'Jepretan layar',
    LIVE: 'Siaran langsung',
    OFF: 'Tutup',
    MINIPLAYER_DRAG: 'Ketuk dan tahan untuk geser video',
    AIRPLAY_TIPS: 'AirPlay',
    onlyPlayTip: 'Hanya bisa diputar {msg} menit, masuk untuk tonton video lengkap',
    loginTextButton: 'Masuk',
    replayButton: 'Putar ulang',
    nextButton: 'Episode berikutnya',
    refreshButton: 'Refresh',
    episode: 'Episode'
  }
  lang.ms = {
    HAVE_NOTHING: 'Tidak ada maklumat tentang audio/video yang sudah sedia ada',
    HAVE_METADATA: 'Metadata audio/video sudah sedia ada',
    HAVE_CURRENT_DATA: 'Data tentang lokasi tayangan semasa boleh digunakan, tetapi data tidak mencukupi untuk menayangkan bingkai/ms seterusnya',
    HAVE_FUTURE_DATA: 'Data semasa dan sekurang-kurangnya bingkai seterusnya boleh digunakan',
    HAVE_ENOUGH_DATA: 'Data yang sedia ada boleh memulakan tayangan',
    NETWORK_EMPTY: 'Audio/video belum dimulakan',
    NETWORK_IDLE: 'Audio/video ialah aktiviti malah sumber telah dipilih, tetapi tidak menggunakan rangkaian',
    NETWORK_LOADING: 'Pelayar sedang muat turun data',
    NETWORK_NO_SOURCE: 'Sumber audio/video tidak ditemui',
    MEDIA_ERR_ABORTED: 'Proses mendapatkan semula telah dihentikan oleh pengguna',
    MEDIA_ERR_NETWORK: 'Ralat berlaku semasa memuat turun',
    MEDIA_ERR_DECODE: 'Analisis tayangan gagal: Tidak dapat menayangkan fail',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Format audio/video yang tidak disokong',
    REPLAY: 'Tayang semula',
    ERROR: 'Sambungan rangkaian bermasalah',
    PLAY_TIPS: 'Tayangkan',
    PAUSE_TIPS: 'Henti',
    PLAYNEXT_TIPS: 'Episod seterusnya',
    DOWNLOAD_TIPS: 'Muat turun',
    ROTATE_TIPS: 'Putar',
    RELOAD_TIPS: 'Memuatkan semula',
    FULLSCREEN_TIPS: 'Masuk ke skrin penuh',
    EXITFULLSCREEN_TIPS: 'Keluar dari skrin penuh',
    CSSFULLSCREEN_TIPS: 'Masuk ke gaya skrin penuh',
    EXITCSSFULLSCREEN_TIPS: 'Keluar dari gaya skrin penuh',
    TEXTTRACK: 'Sari kata',
    PIP: 'Gambar dalam gambar',
    MINIPLAYER: 'Pemain mini',
    SCREENSHOT: 'Tangkapan skrin',
    LIVE: 'Siaran langsung',
    OFF: 'Tutup',
    MINIPLAYER_DRAG: 'Klik dan tahan untuk menggerakkan video',
    AIRPLAY_TIPS: 'Airplay',
    onlyPlayTip: 'Hanya menayang {msg} minit, log masuk untuk menonton filem penuh ',
    loginTextButton: 'Log masuk',
    replayButton: 'Tayangkan semula',
    nextButton: 'Episod seterusnya',
    refreshButton: 'Memuatkan semula',
    episode: 'Episod'
  }
  lang.pt = {
    HAVE_NOTHING: 'Não há informações sobre se o áudio/vídeo está pronto',
    HAVE_METADATA: 'Metadados de áudio/vídeo estão prontos',
    HAVE_CURRENT_DATA: 'Dados sobre a posição de reprodução atual estão disponíveis, mas não há dados suficientes para reproduzir o próximo quadro/ms',
    HAVE_FUTURE_DATA: 'Os dados do quadro atual e pelo menos do próximo estão disponíveis',
    HAVE_ENOUGH_DATA: 'Os dados disponíveis são suficientes para começar a reproduzir',
    NETWORK_EMPTY: 'Áudio/vídeo não foi inicializado',
    NETWORK_IDLE: 'O áudio/vídeo está ativo e o recurso foi selecionado, mas a rede não é usada',
    NETWORK_LOADING: 'O navegador está baixando dados',
    NETWORK_NO_SOURCE: 'Nenhuma fonte de áudio/vídeo encontrada',
    MEDIA_ERR_ABORTED: 'O processo de recuperação foi abortado pelo usuário',
    MEDIA_ERR_NETWORK: 'Ocorreu um erro durante o download',
    MEDIA_ERR_DECODE: 'A análise de reprodução falhou: não foi possível reproduzir o arquivo',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Formato de áudio/vídeo não compatível',
    REPLAY: 'Reproduzir',
    ERROR: 'Parece haver um problema com a conexão de rede',
    PLAY_TIPS: 'Reproduzir',
    PAUSE_TIPS: 'Pausa',
    PLAYNEXT_TIPS: 'Próximo',
    DOWNLOAD_TIPS: 'Baixar',
    ROTATE_TIPS: 'Girar',
    RELOAD_TIPS: 'Recarregar',
    FULLSCREEN_TIPS: 'Entrar em tela inteira',
    EXITFULLSCREEN_TIPS: 'Sair da tela inteira',
    CSSFULLSCREEN_TIPS: 'Entrar em tela inteira padrão',
    EXITCSSFULLSCREEN_TIPS: 'Sair da tela inteira padrão',
    TEXTTRACK: 'Legendas',
    PIP: 'Imagem em imagem',
    MINIPLAYER: 'Mini-leitor',
    SCREENSHOT: 'Captura de tela',
    LIVE: 'Transmissão ao vivo',
    OFF: 'Desligar',
    MINIPLAYER_DRAG: 'Clique e segure para arrastar o vídeo',
    AIRPLAY_TIPS: 'Airplay',
    onlyPlayTip: 'Reproduza apenas {msg} minutos, faça login para assistir o filme completo',
    loginTextButton: 'Login',
    replayButton: 'Reproduzir',
    nextButton: 'Próximo',
    refreshButton: 'Atualizar',
    episode: 'Episódio'
  }
  lang.th = {
    HAVE_NOTHING: 'ไม่มีข้อมูลว่า เสียง/วิดีโอพร้อมหรือไม่',
    HAVE_METADATA: 'ข้อมูลเมตาของเสียง/วิดีโอพร้อมแล้ว',
    HAVE_CURRENT_DATA: 'ข้อมูลเกี่ยวกับตำแหน่งการเล่นปัจจุบันมีให้ แต่มีข้อมูลไม่เพียงพอที่จะเล่นเฟรมถัดไป/ms',
    HAVE_FUTURE_DATA: 'มีข้อมูลของเฟรมปัจจุบันและเฟรมถัดไปเป็นอย่างน้อย',
    HAVE_ENOUGH_DATA: 'ข้อมูลที่มีอยู่เพียงพอที่จะเริ่มเล่น',
    NETWORK_EMPTY: 'เสียง / วิดีโอยังไม่ได้เริ่มต้น',
    NETWORK_IDLE: 'เสียง/วิดีโอใช้งานอยู่ และเลือกทรัพยากรแล้ว แต่ไม่ได้ใช้เครือข่าย',
    NETWORK_LOADING: 'เบราว์เซอร์กำลังดาวน์โหลดข้อมูล',
    NETWORK_NO_SOURCE: 'ไม่พบแหล่งที่มาของเสียง/วิดีโอ',
    MEDIA_ERR_ABORTED: 'กระบวนการดึงกลับถูกผู้ใช้ยกเลิก',
    MEDIA_ERR_NETWORK: 'เกิดข้อผิดพลาดในเวลาดาวน์โหลด',
    MEDIA_ERR_DECODE: 'การแยกวิเคราะห์การเล่นล้มเหลว ไม่สามารถเล่นไฟล์',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'รูปแบบเสียง/วิดีโอที่ไม่รองรับ',
    REPLAY: 'รีเพลย์',
    ERROR: 'ดูเหมือนว่าการเชื่อมต่อเครือข่ายมีปัญหา',
    PLAY_TIPS: 'เล่น',
    PAUSE_TIPS: 'ระงับ',
    PLAYNEXT_TIPS: 'ตอนทัดไป',
    DOWNLOAD_TIPS: 'ดาวน์โหลด',
    ROTATE_TIPS: 'หมุน',
    RELOAD_TIPS: 'โหลดใหม่',
    FULLSCREEN_TIPS: 'เข้าสู่เต็มหน้าจอ',
    EXITFULLSCREEN_TIPS: 'ออกจากเต็มหน้าจอ',
    CSSFULLSCREEN_TIPS: 'เข้ารูปแบบเต็มหน้าจอ',
    EXITCSSFULLSCREEN_TIPS: 'ออกจากรูปแบบเต็มหน้าจอ',
    TEXTTRACK: 'ซับไทเทิล',
    PIP: 'รูปภาพในภาพ',
    MINIPLAYER: 'เครื่องเล่นมินิ',
    SCREENSHOT: 'จับภาพหน้าจอ',
    LIVE: 'กำลังเล่น',
    OFF: 'ปิด',
    MINIPLAYER_DRAG: 'คลิกค้างไว้เพื่อลากวิดีโอ',
    AIRPLAY_TIPS: 'AirPlay',
    onlyPlayTip: 'เล่นเพียง {msg} นาที เข้าสู่ระบบเพื่อชมภาพยนตร์ครบ',
    loginTextButton: 'เข้าสู่ระบบ',
    replayButton: 'เล่นซ้ำ',
    nextButton: 'ตอนทัดไป',
    refreshButton: 'รีเฟรช',
    episode: 'ตอน'
  }
  lang.vi = {
    HAVE_NOTHING: 'Không có sẵn thông tin video/âm thanh',
    HAVE_METADATA: 'Dữ liệu video/âm thanh đã sẵn sàng',
    HAVE_CURRENT_DATA: 'Dữ liệu vị trí đang bật là khả dụng, nhưng không đủ dữ liệu để play video tiếp theo/mili giây',
    HAVE_FUTURE_DATA: 'Dữ liệu hiện tại và tiếp theo là khả dụng',
    HAVE_ENOUGH_DATA: 'Dữ liệu khả dụng đủ để bật',
    NETWORK_EMPTY: 'Video/phim chưa khởi tạo',
    NETWORK_IDLE: 'Video/phim có sẵn và đã được lựa chọn, nhưng chưa sử dụng mạng',
    NETWORK_LOADING: 'Trình duyệt đang tải dữ liệu về',
    NETWORK_NO_SOURCE: 'Chưa tìm được nguồn video/phim',
    MEDIA_ERR_ABORTED: 'Quá trình tải bị người dùng chặn',
    MEDIA_ERR_NETWORK: 'Lỗi khi đang tải về',
    MEDIA_ERR_DECODE: 'Giải tích lỗi: không thể bật',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Không hỗ trợ định dạng video/phim',
    REPLAY: 'Bật lại',
    ERROR: 'Kết nối mạng có vấn đề',
    PLAY_TIPS: 'Bật',
    PAUSE_TIPS: 'Dừng',
    PLAYNEXT_TIPS: 'Tập sau',
    DOWNLOAD_TIPS: 'Tải về',
    ROTATE_TIPS: 'Xoay',
    RELOAD_TIPS: 'Tải lại',
    FULLSCREEN_TIPS: 'Mở to cả màn hình',
    EXITFULLSCREEN_TIPS: 'Thoát cả màn hình',
    CSSFULLSCREEN_TIPS: 'Chế độ cả màn hình',
    EXITCSSFULLSCREEN_TIPS: 'Thoát chế độ cả màn hình',
    TEXTTRACK: 'Phụ đề',
    PIP: 'Picture in picture',
    MINIPLAYER: 'Trình phát thu nhỏ',
    SCREENSHOT: 'Cắt màn hình',
    LIVE: 'Đang livetream',
    OFF: 'Đóng',
    MINIPLAYER_DRAG: 'Nhấp và giữ để kéo video',
    AIRPLAY_TIPS: 'Airplay',
    onlyPlayTip: 'Chỉ xem được {msg} phút, đăng nhập xem toàn tập',
    loginTextButton: 'Đăng nhập',
    replayButton: 'Replay',
    nextButton: 'Tập sau',
    refreshButton: 'Làm mới',
    episode: 'Tập'
  }
  lang['zh_CN'] = {
    HAVE_NOTHING: '没有关于音频/视频是否就绪的信息',
    HAVE_METADATA: '音频/视频的元数据已就绪',
    HAVE_CURRENT_DATA: '关于当前播放位置的数据是可用的，但没有足够的数据来播放下一帧/毫秒',
    HAVE_FUTURE_DATA: '当前及至少下一帧的数据是可用的',
    HAVE_ENOUGH_DATA: '可用数据足以开始播放',
    NETWORK_EMPTY: '音频/视频尚未初始化',
    NETWORK_IDLE: '音频/视频是活动的且已选取资源，但并未使用网络',
    NETWORK_LOADING: '浏览器正在下载数据',
    NETWORK_NO_SOURCE: '未找到音频/视频来源',
    MEDIA_ERR_ABORTED: '取回过程被用户中止',
    MEDIA_ERR_NETWORK: '当下载时发生错误',
    MEDIA_ERR_DECODE: '当解码时发生错误',
    MEDIA_ERR_SRC_NOT_SUPPORTED: '不支持的音频/视频格式',
    REPLAY: '重播',
    ERROR: '网络连接似乎出现了问题',
    PLAY_TIPS: '播放',
    PAUSE_TIPS: '暂停',
    PLAYNEXT_TIPS: '下一集',
    DOWNLOAD_TIPS: '下载',
    ROTATE_TIPS: '旋转',
    RELOAD_TIPS: '重新载入',
    FULLSCREEN_TIPS: '进入全屏',
    EXITFULLSCREEN_TIPS: '退出全屏',
    CSSFULLSCREEN_TIPS: '进入样式全屏',
    EXITCSSFULLSCREEN_TIPS: '退出样式全屏',
    TEXTTRACK: '字幕',
    PIP: '画中画',
    MINIPLAYER: '迷你播放器',
    SCREENSHOT: '截图',
    LIVE: '正在直播',
    OFF: '关闭',
    MINIPLAYER_DRAG: '点击按住可拖动视频',
    AIRPLAY_TIPS: '隔空播放'
  }
  lang['zh_TW'] = {
    HAVE_NOTHING: '沒有關於音頻/視頻是否就緒的信息',
    HAVE_METADATA: '音頻/視頻的元數據已就緒',
    HAVE_CURRENT_DATA: '關於當前播放位置的數據是可用的，但沒有足夠的數據來播放下壹幀/毫秒',
    HAVE_FUTURE_DATA: '當前及至少下壹幀的數據是可用的',
    HAVE_ENOUGH_DATA: '可用數據足以開始播放',
    NETWORK_EMPTY: '音頻/視頻尚未初始化',
    NETWORK_IDLE: '音頻/視頻是活動的且已選取資源，但並未使用網絡',
    NETWORK_LOADING: '瀏覽器正在下載數據',
    NETWORK_NO_SOURCE: '未找到音頻/視頻來源',
    MEDIA_ERR_ABORTED: '取回過程被用戶中止',
    MEDIA_ERR_NETWORK: '當下載時發生錯誤',
    MEDIA_ERR_DECODE: '當解碼時發生錯誤',
    MEDIA_ERR_SRC_NOT_SUPPORTED: '不支持的音頻/視頻格式',
    REPLAY: '重播',
    ERROR: '網絡連接似乎出現了問題',
    PLAY_TIPS: '播放',
    PAUSE_TIPS: '暫停',
    PLAYNEXT_TIPS: '下壹集',
    DOWNLOAD_TIPS: '下載',
    ROTATE_TIPS: '旋轉',
    RELOAD_TIPS: '重新載入',
    FULLSCREEN_TIPS: '進入全屏',
    EXITFULLSCREEN_TIPS: '退出全屏',
    CSSFULLSCREEN_TIPS: '進入樣式全屏',
    EXITCSSFULLSCREEN_TIPS: '退出樣式全屏',
    TEXTTRACK: '字幕',
    PIP: '畫中畫',
    MINIPLAYER: '迷妳播放器',
    SCREENSHOT: '截圖',
    LIVE: '正在直播',
    OFF: '關閉',
    MINIPLAYER_DRAG: '點擊按住可拖動視頻',
    AIRPLAY_TIPS: '隔空播放'
  }

  Object.defineProperty(player, 'lang', {
    get: function () {
      if (player.config) {
        return lang[player.config.lang] || lang['en']
      } else {
        return lang['en']
      }
    },
    set: function (value) {
      if (typeOf(value) === 'Object') {
        Object.keys(value).forEach((key) => {
          lang[key] = value[key]
        })
      }
    }
  })
}

export default {
  name: 's_i18n',
  method: s_i18n
}
